export default {"src":"/_next/static/media/kids.d06e7432.svg","height":116,"width":107,"blurWidth":0,"blurHeight":0};